<template>
    <div class="footer">
        <el-row justify="center">
            <el-col :xs="24" :sm="8" :md="6">
                <div class="footer-content">
                    <h3>版权所有</h3>
                    <p>青岛上赛云软件有限公司</p>
                </div>

            </el-col>
            <el-col :xs="24" :sm="8" :md="6">
                <div class="footer-content">
                    <h3>备案号</h3>
                    <p><el-link href="https://beian.miit.gov.cn" traget="_blank"
                            underline="never">鲁ICP备2023052212号</el-link></p>
                    <p><el-image class="thumbimg" fit="fill" :src="imagedata" /><el-link
                            href="https://beian.mps.gov.cn/#/query/webSearch?code =37020202370292" rel="noreferrer"
                            traget="_blank" underline="never">鲁公网安备37020202370292</el-link></p>
                </div>

            </el-col>
            <el-col :xs="24" :sm="8" :md="6">
                <div class="footer-content">
                    <h3>隐私</h3>
                    <p><el-link title="查看隐私保护声明" href="/privacystatement" underline="never"><span>隐私保护声明</span></el-link></p>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script lang="ts" setup>
import { ElRow, ElCol, ElLink, ElImage } from 'element-plus';
import imagedata from '../assets/gonan.png';
</script>

<style lang="scss" scoped>
.footer {
    background: #f9f9f9;
    color: rgba(60, 60, 60, .7);
    padding: 16px 0;
    position: relative;
    width: 100%;
    bottom: 0;

    .footer-content {
        font-size: 14px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        padding: 0 20px;
    }

    h3 {
        margin-bottom: 0.5rem;
        color: #333;
    }

    p {
        display: flex;
        align-items: center;
        margin: 5px 0;

        .thumbimg {
            width: 14px;
        }
    }
}
</style>